import { render } from "./form-collapse.vue?vue&type=template&id=3edebaa6"
import script from "./form-collapse.vue?vue&type=script&lang=js"
export * from "./form-collapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__